// This OTP is shown on screen for demo email verification.
export const DEMO_EMAIL_OTP = "246810";

// These steps are taken from the company registration flow in the PDF.
export const registrationSteps = [
  "Welcome",
  "Company Info",
  "Owner Contact",
  "Package",
  "Payment",
  "Setup",
  "Invite Manager",
  "Dashboard",
];

// This is temporary local form data. Later it can come from API or database.
export const initialRegistrationForm = {
  language: "English",
  companyName: "",
  businessType: "",
  customBusinessType: "",
  city: "",
  gstin: "",
  ownerName: "",
  email: "",
  mobile: "",
  password: "",
  emailOtp: "",
  emailVerificationToken: "",
  plan: "Trial",
  paymentMethod: "UPI",
  department: "Sales",
  departments: ["Sales"],
  departmentOption: "Sales",
  customDepartment: "",
  workingStart: "09:00",
  workingEnd: "18:00",
  logoName: "",
  managerName: "",
  managerDepartment: "Sales",
  managerEmail: "",
  managerMobile: "",
  employeeName: "",
  employeeDepartment: "Sales",
  employeeEmail: "",
  employeeMobile: "",
};

export const businessTypes = [
  "Select business type",
  "Retail",
  "Trading",
  "Manufacturing",
  "Services",
  "Construction",
  "Healthcare",
  "Education",
  "Other",
];

export const hindiBusinessTypes = {
  "Select business type": "व्यवसाय प्रकार चुनें",
  Retail: "रिटेल",
  Trading: "ट्रेडिंग",
  Manufacturing: "मैन्युफैक्चरिंग",
  Services: "सर्विसेज",
  Construction: "कंस्ट्रक्शन",
  Healthcare: "हेल्थकेयर",
  Education: "एजुकेशन",
  Other: "अन्य",
};

export const plans = [
  {
    name: "Trial",
    price: "Rs. 9",
    detail: "1 month",
    features: ["10 users", "Tasks", "Attendance", "Email alerts"],
  },
  {
    name: "Starter",
    price: "Rs. 299",
    detail: "per month",
    features: ["Growing teams", "Invoices", "Basic reports"],
  },
  {
    name: "Growth",
    price: "Rs. 699",
    detail: "per month",
    features: ["More users", "Advanced reports", "Priority support"],
  },
];

export const copy = {
  English: {
    back: "Back",
    step: "Step",
    of: "of",
    ownerRegistration: "Owner / Company Registration",
    sideTitle: "Register in minutes, start managing today.",
    emailOtp: "Email OTP",
    emailOtpText: "",
    inviteReady: "Invite ready",
    inviteReadyText: "",
    invoiceTitle: "GST invoice",
    invoiceText: "Generated after payment",
    welcomeTitle: "Welcome to KaamDesk",
    welcomeSub: "Choose your preferred language and begin company registration.",
    registerCompany: "Register your company",
    companyTitle: "Company Basic Info",
    companySub: "Tell us about your business. All required fields must be completed.",
    companyName: "Company Name",
    businessType: "Business Type",
    city: "City",
    gstin: "GSTIN",
    optional: "Optional",
    cityHelp: "Auto-detect later or type manually now",
    gstHelp: "Used only for invoice generation",
    saveContinue: "Save & Continue",
    ownerTitle: "Owner Contact",
    ownerSub: "Verify owner email with OTP.",
    testingOtp: "Testing Email OTP:",
    otpSendFirst: "Click Send OTP. The same OTP sent by email will show here for local testing.",
    sendOtp: "Send OTP",
    sendingOtp: "Sending...",
    otpSent: "OTP sent to email.",
    otpExpiresIn: "OTP expires in",
    otpExpired: "OTP expired. Send a new OTP.",
    otpMissingFromBackend: "OTP was sent, but testing OTP was not returned by backend. Check SMTP_SHOW_TEST_OTP in backend/config/smtp.php.",
    ownerName: "Owner Full Name",
    email: "Email Address",
    mobile: "Mobile Number",
    mobileHelp: "Enter 10 digit mobile number",
    mobileInvalid: "Please enter a valid 10 digit mobile number.",
    checkingDuplicate: "Checking availability...",
    emailHelp: "Enter the Email, so we use email verification for now",
    enterOtp: "Enter Email OTP",
    otpHelp: "Enter the OTP sent to email.",
    verify: "Verify",
    verified: "Verified",
    emailVerified: "Email verified.",
    packageTitle: "Package Selection",
    packageSub: "Trial is pre-selected by default.",
    preSelected: "Pre-selected",
    continuePayment: "Continue to Payment",
    paymentTitle: "Payment",
    paymentSub: "Complete payment securely with Razorpay.",
    razorpay: "Razorpay secure payment",
    invoiceEmail: "GST invoice will be sent to Email",
    paymentSuccess: "Payment successful. GST invoice generated.",
    continueSetup: "Continue Setup",
    setupTitle: "Company Setup",
    setupSub: "Optional details to personalize your workspace.",
    uploadLogo: "Upload Logo",
    uploadHelp: "Optional, PNG/JPG up to 2MB",
    timezone: "Company Time Zone",
    department: "First Department Name",
    inviteTitle: "Invite First Manager",
    inviteSub: "Send an email invite or skip for now.",
    managerEmail: "Manager Email",
    managerMobile: "Manager Mobile",
    managerMobileHelp: "Required when sending manager invite link",
    sendInvite: "Send Email Invite",
    skip: "Skip for now",
    inviteSent: "Invite sent by email. You can add managers later too.",
    finish: "Finish Registration",
    complete: "Registration complete",
    dashboardTitle: "Welcome, Owner (Malik)",
    ready: "is ready.",
    checklist: "Quick-start checklist",
    addTeam: "Add team",
    addTeamText: "Invite managers and team members",
    createProject: "Create first project",
    createProjectText: "Group recurring work",
    assignTask: "Assign first task",
    assignTaskText: "Send notification",
    goDashboard: "Go to Dashboard",
    goLogin: "Go to Login",
    login: "Login",
    teamMembers: "Team members",
    openTasks: "Open tasks",
    currentPlan: "Current plan",
    validationRequired: "Please complete required fields before continuing.",
    emailInvalid: "Please enter a valid email.",
    gstInvalid: "GSTIN must be 15 characters.",
    otpInvalid: "Please verify email OTP.",
  },
  Hindi: {
    back: "वापस",
    step: "स्टेप",
    of: "में से",
    ownerRegistration: "Owner / Company Registration",
    sideTitle: "कुछ मिनटों में रजिस्टर करें और काम शुरू करें।",
    emailOtp: "ईमेल OTP",
    emailOtpText: "अभी फ्री वेरिफिकेशन",
    inviteReady: "इनवाइट तैयार",
    inviteReadyText: "मैनेजर ऑनबोर्डिंग फ्लो",
    invoiceTitle: "GST इनवॉइस",
    invoiceText: "पेमेंट के बाद बनेगी",
    welcomeTitle: "KaamDesk में आपका स्वागत है",
    welcomeSub: "अपनी भाषा चुनें और कंपनी रजिस्ट्रेशन शुरू करें।",
    registerCompany: "अपनी कंपनी रजिस्टर करें",
    companyTitle: "कंपनी की बेसिक जानकारी",
    companySub: "अपने व्यवसाय की जानकारी भरें। सभी जरूरी फील्ड भरना अनिवार्य है।",
    companyName: "कंपनी का नाम",
    businessType: "व्यवसाय प्रकार",
    city: "शहर",
    gstin: "GSTIN",
    optional: "वैकल्पिक",
    cityHelp: "अभी शहर लिखें, बाद में auto-detect जोड़ा जा सकता है",
    gstHelp: "यह केवल इनवॉइस बनाने के लिए उपयोग होगा",
    saveContinue: "सेव करके आगे बढ़ें",
    ownerTitle: "Owner Contact",
    ownerSub: "फ्री OTP login के लिए owner email verify करें।",
    testingOtp: "Testing Email OTP:",
    otpSendFirst: "Send OTP पर click करें। Email पर भेजा गया वही OTP local testing के लिए यहां दिखेगा।",
    sendOtp: "OTP भेजें",
    sendingOtp: "भेजा जा रहा है...",
    otpSent: "OTP email पर भेज दिया गया।",
    otpExpiresIn: "OTP expires in",
    otpExpired: "OTP expire हो गया। नया OTP भेजें।",
    otpMissingFromBackend: "OTP भेजा गया, लेकिन backend ने testing OTP return नहीं किया। backend/config/smtp.php में SMTP_SHOW_TEST_OTP check करें।",
    ownerName: "Owner का पूरा नाम",
    email: "ईमेल एड्रेस",
    mobile: "मोबाइल नंबर",
    mobileHelp: "Owner का 10 digit Indian mobile number डालें",
    mobileInvalid: "कृपया valid 10 digit mobile number डालें।",
    checkingDuplicate: "Availability check हो रही है...",
    emailHelp: "Email OTP free है, इसलिए अभी email verification इस्तेमाल होगा",
    enterOtp: "Email OTP डालें",
    otpHelp: "Email पर भेजा गया OTP डालें। Local testing में वही OTP ऊपर दिखेगा।",
    verify: "Verify करें",
    verified: "Verified",
    emailVerified: "Email verify हो गया। SMS charge की जरूरत नहीं।",
    packageTitle: "Package Selection",
    packageSub: "Trial default रूप से selected है।",
    preSelected: "पहले से selected",
    continuePayment: "Payment पर जाएं",
    paymentTitle: "Payment",
    paymentSub: "Razorpay से सुरक्षित payment पूरा करें।",
    razorpay: "Razorpay secure payment",
    invoiceEmail: "GST invoice Email पर भेजी जाएगी",
    paymentSuccess: "Payment successful. GST invoice बन गई।",
    continueSetup: "Setup जारी रखें",
    setupTitle: "Company Setup",
    setupSub: "Workspace को personalize करने के लिए optional details भरें।",
    uploadLogo: "Logo Upload करें",
    uploadHelp: "Optional, PNG/JPG up to 2MB",
    timezone: "Company Time Zone",
    department: "पहले department का नाम",
    inviteTitle: "पहले Manager को Invite करें",
    inviteSub: "Email invite भेजें या अभी skip करें।",
    managerEmail: "Manager Email",
    managerMobile: "Manager Mobile",
    managerMobileHelp: "Manager invite link bhejne ke liye required",
    sendInvite: "Email Invite भेजें",
    skip: "अभी Skip करें",
    inviteSent: "Email invite भेज दिया गया। Manager बाद में भी add कर सकते हैं।",
    finish: "Registration पूरा करें",
    complete: "Registration complete",
    dashboardTitle: "Welcome, Owner (Malik)",
    ready: "तैयार है।",
    checklist: "Quick-start checklist",
    addTeam: "Team add करें",
    addTeamText: "Managers और team members invite करें",
    createProject: "पहला project बनाएं",
    createProjectText: "बार-बार होने वाले काम group करें",
    assignTask: "पहला task assign करें",
    assignTaskText: "Notification भेजें",
    goDashboard: "Dashboard पर जाएं",
    teamMembers: "Team members",
    openTasks: "Open tasks",
    currentPlan: "Current plan",
    validationRequired: "आगे बढ़ने से पहले जरूरी जानकारी भरें।",
    emailInvalid: "कृपया सही email address डालें।",
    gstInvalid: "GSTIN 15 characters का होना चाहिए।",
    otpInvalid: "कृपया email OTP verify करें।",
  },
};
